import moment from 'moment';
import React, { memo, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import { ECMWFAppsAPIResponse } from './ServiceStatus.types';
import IS_EFAS from '../../components/sitebase/Environment';

export const ECMWFServiceStatus = memo(() => {

    const [notifications, setNotificaitons] = useState<React.JSX.Element[]>();
    const [sessions, setSessions] = useState<React.JSX.Element[]>();
    const [loading, setLoading] = useState<boolean>(true);

    const UnixDateToString = (UNIX_timestamp: string) => {
        return moment.unix(UNIX_timestamp as unknown as number).format("DD/MM/YYYY - HH:mm z");
    };

    useEffect(() => {
        const url = IS_EFAS ? 'https://apps.ecmwf.int/status/status/EFAS' : 'https://apps.ecmwf.int/status/status/GLOFAS';
        fetch(url)
            .then(response => response.json())
            .then((json: ECMWFAppsAPIResponse) => {
                setNotificaitons(json.notifications.splice(0, 14).map((session) => {
                    return (<tr>
                        <td>{UnixDateToString(session.node['Post date'])}</td>
                        <td>{session.node.Title}</td>
                        <td>{session.node.Type}</td>
                    </tr>)
                }));
                setSessions(json.sessions.splice(0, 14).map((session) => {
                    return (<tr>
                        <td>{UnixDateToString(session.node['Start Time'])}</td>
                        <td>{session.node.Title}</td>
                        <td>{session.node.Impact}</td>
                        <td>{session.node.Duration} minutes</td>
                    </tr>)
                }))
            }).catch((error) => { console.log(error) })
            .finally(() => setLoading(false));
    }, []);

    return (
        loading ? <LoadingSpinner /> :
            <div>
                <h1>Service Status</h1>
                <p>For full details please check out the <a href='https://www.ecmwf.int/en/service-status' target='_blank'>ECMWF Service Status</a> page.</p>
                <h3>Notifications</h3>
                <Table>
                    <thead>
                        <tr>
                            <th scope='col'>Date</th>
                            <th scope='col'>Title</th>
                            <th scope='col'>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {notifications}
                    </tbody>
                </Table>
                <h3>Sessions</h3>
                <Table>
                    <thead>
                        <tr>
                            <th scope='col'>Date</th>
                            <th scope='col'>Title</th>
                            <th scope='col'>Impact</th>
                            <th scope='col'>Duration</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sessions}
                    </tbody>
                </Table>
            </div>
    );
});
